import { isFirefox, isIOS, isSafari } from 'react-device-detect';

import { Capabilities, CapabilityEnv, deriveCapabilities } from 'devices/core';

/**
 * Runtime adapter — the one place that reads globals to feed the pure Phase 0 behaviour model.
 * Existence flags are feature-detected; UA flags come from `react-device-detect` (the same source
 * `canAutoPrompt` uses today).
 *
 * Lives in `utils/` (alongside the other UA-reading helper, `canAutoPrompt`) rather than `gate/`
 * so the acquisition thunks in `state/` can read capabilities without importing the React facade.
 * `gate/` re-exports it, so `import { getCapabilities } from 'devices/gate'` still works.
 */
export const readCapabilityEnv = (): CapabilityEnv => ({
  hasGetUserMedia: typeof navigator !== 'undefined' && !!navigator.mediaDevices?.getUserMedia,
  hasPermissionsQuery: typeof navigator !== 'undefined' && typeof navigator.permissions?.query === 'function',
  hasSetSinkId: typeof HTMLMediaElement !== 'undefined' && 'setSinkId' in HTMLMediaElement.prototype,
  isSafari,
  isIOS,
  isFirefox,
});

/** Resolve the current environment's {@link Capabilities} from live globals. */
export const getCapabilities = (): Capabilities => deriveCapabilities(readCapabilityEnv());
